module.exports = __webpack_public_path__ + "static/img/phones.7897b5ae.png";